// extracted by mini-css-extract-plugin
export var active = "_9s-7";
export var container = "_9s-0";
export var evenWidth = "_9s-4";
export var large = "_9s-5";
export var outlet = "_9s-8";
export var slide = "_9s-2";
export var small = "_9s-6";
export var tab = "_9s-3";
export var tabs = "_9s-1";